import React from 'react'
import { CFSelect, CFView, LocationSelect, MobileScreen } from 'components'
import Header from './Header'
import Hero from './Hero'
import Promotions from './Promotions'
import About from './About'
import Gallery from './Gallery'
import Contact from './Contact'
import Footer from './Footer'
import { homebg } from 'images'
import WelcomeModal from './WelcomeModal'
import { dispatch } from 'store'

export default () => {
  // dispatch.restaurant.setRestaurantId('tL7i3BqYo1WYnmr5pY6r')
  // dispatch.restaurant.setLocationId('qWH8FnkVNSHCSARq16v7')
  return (
    <CFView row justifyCenter>
      <CFView maxWidth="1400px" w="100%">
        {/* <MobileScreen>
          <LocationSelect />
        </MobileScreen> */}
        {/* <Header /> */}
        <Hero />
        <CFView maxWidth="1400px" m="0 auto" bw={1.5} btw={0} bbw={0}>
          <Promotions />
          {/* <About /> */}
          <Gallery />
        </CFView>
        <Contact />
        <Footer />
      </CFView>{' '}
      <CFSelect selector={dispatch.restaurant.getWelcomeMessage}>
        <WelcomeModal />
      </CFSelect>
    </CFView>
  )
}
